import {
  gql
} from "@apollo/client";
export const GET_REALWEDDING_QUERY = gql`
    query getAllRealWedding(
        $color_id: String
        $category_id: String
        $currentPage: Int!
        $pageSize: Int!
    ) {
        allRealWedding(
            filter: {
                category_id: { eq: $category_id }
                color_id: { eq: $color_id }
            }
            currentPage: $currentPage
            pageSize: $pageSize
        ) {
            items {
                id
                skus
                pic
                alt
                link
                position
                colors {
                    id
                    type
                    label
                    rgb
                    thumbnail
                    link
                    position
                    __typename
                }
            }
            page_info {
                page_size
                current_page
                total_pages
            }
            total_count
            categories {
                ids
                label
                count
            }
            colors {
                ids
                type
                label
                rgb
                thumbnail
                count
            }
        }
    }
`;
export default {
  getRealWeddingPageQuery: GET_REALWEDDING_QUERY
};
